import { Award, Shield, Users } from "lucide-react";

export const NavMenu = {
  image: "/images/gsdental/Logo_gsdentalXL.svg",
  href: "#home",
  alt: "Logo GS Dental",
  id: "contact",
  menu: [
    { name: "Inicio", href: "#home" },
    { name: "Nosotros", href: "#about" },
    { name: "Servicios", href: "#services" },
    { name: "Testimonios", href: "#testimonials" },
    { name: "Visítanos", href: "#contact" },
  ],
};

export const footerOptions = {

  image: {
    name: "/images/gsdental/Logo_gsdentalXL.svg",
    width: 420,
    height: 50,
    alt: "Logo GS Dental",
  },

  href: "#home",
  id: "contact",
  companyAddress: {
    city: "Guayaquil",
    rest: "- Torre Médica Solaris Piso 5 Consultorio 110 - 111",
  },
  companyHours: [
    "Lunes a Viernes 10:00 - 19:00.",
    "Sábados 10:00 - 14:00.",
    "Domingos y Feriados Cerrado",
  ],

  href: "#home",
  id: "contact",
  companyAddress2: {
    city: "Cuenca",
    rest: "- Av. Don Bosco, y La Pinta, 010205",
  },
  companyHours2: [
    "Lunes a Viernes 10:00 - 19:00.",
    "Sábados 10:00 - 14:00.",
    "Domingos y Feriados Cerrado",
  ],

  telf1: "+593 98 338 6589",
  telf2: "+593 98 102 3968",
  emailParts: ["adm", "inis", "tracion", "@", "gs", "dental.", "ec"],
  emailDisplay: "adm••••••",
  emailDomain: "gsdental.ec",
  whatsapp: "+593 98 338 6589",
  products: {
    title: "Servicios",
    items: [
      { name: "Blanqueamiento Dental", link: "#services" },
      { name: "Ortodoncia", link: "#services" },
      { name: "Diseño de Sonrisa", link: "#services" },
      { name: "Odontología General", link: "#services" },
    ],
  },
  socialMedia: {
    title: "Síguenos",
    links: [
      {
        name: "Instagram",
        url: "https://www.instagram.com/gs_dental",
        icon: "instagram",
      },
      {
        name: "Facebook",
        url: "https://www.facebook.com/gsdentalka",
        icon: "facebook",
      },
      {
        name: "TikTok",
        url: "https://www.tiktok.com/@gsdental.ec",
        icon: "tiktok",
      },
    ],
  },
  terms: {
    title: "Términos & Condiciones",
    items: ["Políticas de la compañia", "Privacidad de Datos", "Términos"],
  },
  companyName: "GS Dental",
};

export const gsdentalStats = [
  { number: null, start: 0, label: "Años de Experiencia", icon: Award },
  { number: 4867, start: 3500, label: "Pacientes Atendidos", icon: Users },
  { number: 5, start: 0, label: "Especialistas", icon: Shield },
];

// *Link para WhatsApp de GsDental
export const gsdentalWhatsAppLink = "https://wa.link/vfd107";
